import { Controller } from "@hotwired/stimulus";

// Shows the level3/level6/level10 sections by the ability's level, and any section that has text.
export default class extends Controller {
	static targets = ["levelSelect", "level3Section", "level6Section", "level10Section"];

	connect() {
		this.updateVisibility();
	}

	change() {
		this.updateVisibility();
	}

	updateVisibility() {
		const level = Number.parseInt(this.levelSelectTarget.value, 10);

		this.toggleSection(this.level3SectionTarget, level === 1);
		this.toggleSection(this.level6SectionTarget, level <= 3);
		this.toggleSection(this.level10SectionTarget, level <= 6);
	}

	toggleSection(section, show) {
		// Tiptap copies its text to the textarea only on submit, so the live editor is the source.
		const editor = section.querySelector(".ProseMirror");
		const typed = (editor ? editor.textContent : section.querySelector('[data-tiptap-target="input"]')?.value)?.trim();
		section.classList.toggle("hidden", !show && !typed);
	}
}
